import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { ProcessEtape } from "../models/process_etape.model";
import { Nomenclature } from "../../nomenclature/models/nomenclature.model";
import { safeFirstValueFrom } from "../../../shared/utils/safe-first-value-from";

@Injectable({
  providedIn: "root",
})
export class ProcessEtapeApiService {
  constructor(private http: HttpClient) {}

  async delete(p: ProcessEtape, specificationEtapeId: string) {
    return await safeFirstValueFrom(
      this.http.delete(
        `${environment.api()}/specification_etape/process/delete/id/${p.id}/specif_etape_id/${specificationEtapeId}`,
      ),
    );
  }

  async save(p: ProcessEtape) {
    return await safeFirstValueFrom(
      this.http.post<ProcessEtape>(
        `${environment.api()}/specification_etape/process`,
        p,
      ),
    );
  }

  async duplicate(p: ProcessEtape) {
    return await safeFirstValueFrom(
      this.http.post<ProcessEtape>(
        `${environment.api()}/specification_etape/process/duplicate`,
        p,
      ),
    );
  }

  async uploadDoc(pId: string, docId: string) {
    return await safeFirstValueFrom(
      this.http.post<ProcessEtape>(
        `${environment.api()}/specification_etape/process/upload_doc/pId/${pId}/${docId}`,
        null,
      ),
    );
  }

  async saveNomenclature(nomenclature: Nomenclature) {
    return await safeFirstValueFrom(
      this.http.post<Nomenclature>(
        `${environment.api()}/specification_etape/nomenclature`,
        nomenclature,
      ),
    );
  }
}
